import {useState} from "react";
import {useQuery} from "react-query";
import axios from "services/axios";

function mapApiItemToRow(item, index) {
	const fullName = item?.user?.fullName || [item?.user?.firstName, item?.user?.lastName].filter(Boolean).join(" ");
	const staffName = fullName || item?.staff?.name || item?.staffName || item?.name || "-";

	let durationSecs = Math.max(0, Number(item?.userDurationSeconds ?? 0) || 0);

	return {
		id: item?.id ?? index + 1,
		userId: item?.userId ?? item?.user?.id ?? null,
		staffId: item?.staffId ?? item?.staff?.id ?? null,
		idSerial: index + 1,
		staffName,
		userDurationSeconds: durationSecs,
	};
}

async function getAttendanceStaff(filter) {
	const {
		hospitalId,
		hospitalIds,
		date,
		startDate,
		endDate,
		page = 1,
		limit = 10,
		search = "",
		orderBy = "checkInDate",
		sortBy = "DESC",
		durationHospitalIdsByUser,
	} = filter || {};

	const rangeFrom = startDate || date;
	const rangeTo = endDate || date;

	const params = {
		...(hospitalId ? {hospitalId} : {}),
		search: search || undefined,
		orderBy,
		sortBy,
		limit,
		page,
	};

	if (Array.isArray(hospitalIds) && hospitalIds.length > 0) {
		params.hospitalIds = hospitalIds.join(",");
	}

	if (durationHospitalIdsByUser && Object.keys(durationHospitalIdsByUser || {}).length > 0) {
		params.durationHospitalIdsByUser = JSON.stringify(durationHospitalIdsByUser);
	}

	if (rangeFrom && rangeTo) {
		params.checkInDate = `${rangeFrom},${rangeTo}`;
	}
	const {data: resp} = await axios.get("/staff/attendances", {params});
	const payload = resp || {};
	const listData = payload?.data || {};
	const apiRows = Array.isArray(listData?.rows) ? listData.rows : Array.isArray(payload?.rows) ? payload.rows : [];
	const rows = apiRows.map((it, idx) => mapApiItemToRow(it, idx));

	const totalItems = listData?.totalItems ?? payload?.totalItems ?? rows.length;
	const totalPages = listData?.totalPages ?? payload?.totalPages ?? 1;
	const currentPage = listData?.currentPage ?? payload?.currentPage ?? page;

	return {
		success: true,
		data: {
			rows,
			totalItems,
			totalPages,
			currentPage,
		},
	};
}

export function useStaffAttendanceSuperAdmin() {
	const [filter, setFilter] = useState({
		hospitalId: null,
		hospitalIds: [],
		date: undefined,
		page: 1,
		limit: 10,
		search: "",
		orderBy: "checkInDate",
		sortBy: "DESC",
		durationHospitalIdsByUser: {},
	});
	const fallback = {success: true, data: {rows: [], totalItems: 0, totalPages: 0, currentPage: 1}};

	const {
		data = fallback,
		isLoading,
		isError,
		error,
	} = useQuery(["attendance-staff-superadmin", filter], async () => getAttendanceStaff(filter), {
		// keepPreviousData: true,
	});

	return {data, isLoading, isError, error, filter, setFilter};
}
